import { render, staticRenderFns } from "./aims.vue?vue&type=template&id=1bf6d366"
import script from "./aims.vue?vue&type=script&lang=js"
export * from "./aims.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports